import React, { useEffect, useState, Fragment, Component, useRef } from 'react'
import { accessRole } from "../../../../helpers/access_role"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'

import TableComponent from './Components/TableComponent'

import IndexBloc from '../Index/Blocs/IndexBloc_'

const DetailView = (props) => {
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            <Link to='/kepegawaian/mutasi_pegawai.html'>
                                <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                            </Link>
                        </div>
                        <CardTitle>Mutasi Pegawai</CardTitle>
                        <CardSubtitle className="mb-3">
                            Detail Mutasi Pegawai
                        </CardSubtitle>
                        <hr/>
                        <TableComponent uuid={props.uuid} ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}
export default DetailView